// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"211b350a5da7d6339abd","655":"e4a48c0303df60de13bf"}[chunkId] + ".js";
};